const ApuracaoContratoEpoca = () => import('@/spa/apuracao-contrato-epoca/ApuracaoContrato');

export default {
  path: 'apuracao-contrato-epoca',
  name: 'apuracao-contrato-epoca',
  component: ApuracaoContratoEpoca,
};
